import { useQuery } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests';
import { User } from '../../../../types';
import { useSubscribeToUserUpdated } from '../../../../websocketApi';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { AUTH_BASE_PATH } from '../../constants/authenticationPath';
import { getMe } from '../../requests/getMe';

export const useMe = (options?: {
  params?: RequestConfig['params'];
  enabled?: boolean;
}) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    NonPaginatedResponse<User> | undefined
  >({
    queryKey: [AUTH_BASE_PATH, 'me', options?.params],
    queryFn: () => getMe(constructGet, options?.params),
    enabled: options?.enabled !== false,
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'me'),
    ...rest,
  };
};
